import React from 'react';

interface TabButtonProps {
    isActive: boolean;
    onClick: () => void;
    title: string;
    className?: string;
}

const TabButton: React.FC<TabButtonProps> = ({
    isActive,
    onClick,
    title,
    className = 'tab-button',
}) => {
    return (
        <button
            className={`${className} ${isActive ? 'active' : ''}`}
            onClick={onClick}
            type="button"
        >
            {title}
        </button>
    );
};

export default TabButton;
